import { lazy } from "react";

const HelpSupportPage = lazy(() =>
  import("@/pages/vendor/help-support").then((m) => ({
    default: m.HelpSupportPage,
  })),
);
const TopicFaqPage = lazy(() =>
  import("@/pages/vendor/help-support").then((m) => ({
    default: m.TopicFaqPage,
  })),
);
const FaqDetailPage = lazy(() =>
  import("@/pages/vendor/help-support").then((m) => ({
    default: m.FaqDetailPage,
  })),
);

// No RouteGuard — like my-requests, every store member can see
// help & support content; there's no resource:action gate for it.
const HelpSupportRoutes = {
  path: "help-support",
  children: [
    { path: "", element: <HelpSupportPage /> },
    { path: ":category", element: <TopicFaqPage /> },
    { path: ":category/:faqId", element: <FaqDetailPage /> },
  ],
};

export default HelpSupportRoutes;
